import { NavigateFunction } from "react-router-dom";
import { CreateRecordResponse } from "../../../../components/BrieChatMenu/GPTConvoTypes";

import { Prefill } from "../../../../types/GlobalInterfaces";
import { getDefaultStore } from "jotai";
import {
  createRecordFamily,
  prefillFamily,
} from "../../../../components/PageView/PageViewTable/SharedToolbar/SharedToolbar";

interface Props {
  message: CreateRecordResponse;
  navigate: NavigateFunction;
  prefills: Prefill[];
  setCreateRecord: ((b: boolean) => void) | undefined;
  setPrefill: ((p: Prefill | null) => void) | undefined;
}

export function createRecordCommand({
  message,
  navigate,
  prefills,
  setCreateRecord,
  setPrefill,
}: Props) {
  setCreateRecord && setCreateRecord(true);

  if (setPrefill && prefills && message?.Template && prefills?.length) {
    const foundPrefill = prefills.find((p) => p.Name === message.Template);

    foundPrefill && setPrefill(foundPrefill);

    return;
  }

  if (message.URL !== window.location.href) {
    navigate(
      `/clouds/${message.TenantID}/workspaces/${message.WorkspaceID}/pages/${message.PageID}/views/${message.ViewID}?prefill=${message.Template}`
    );
  } else {
    updatePrefillAtoms(message, prefills);
  }
}

function updatePrefillAtoms(
  message: CreateRecordResponse,
  prefills: Prefill[]
) {
  const store = getDefaultStore();

  const foundPrefill = prefills.find((p) => p.Name === message.Template);

  if (!foundPrefill) {
    return store.set(createRecordFamily(message?.ViewID), true);
  }

  store.set(prefillFamily(message?.ViewID), foundPrefill);
  store.set(createRecordFamily(message?.ViewID), true);
}
